export default __webpack_public_path__ + "static/media/studio-display-signatures.e4742ee1.png";